import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getGameById } from "../api/game";
import flechaAvanzar from "../assets/right-arrow.svg";
import { ROUTES } from "../utils/constants";
import { updateStats } from "../utils/helpers";
import presentacionDfVideo from "../assets/avatares/presentacion-cobega.mp4";
import { useVideoWithSound } from "../hooks/useVideoWithSound";
import { useVideoContinueGate } from "../hooks/useVideoContinueGate";
import "./StartGame.css";

function GameIntroduction() {
	const navigate = useNavigate();
	const game = useSelector((state) => state.game);
	const group = useSelector((state) => state.group);
	const [loading, setLoading] = useState(false);

	const { videoRef } = useVideoWithSound({
		autoPlay: true,
		volume: 0.8,
	});
	const canContinue = useVideoContinueGate(videoRef);
	const ctaDisabled = loading || !canContinue;

	const handleStartGame = (e) => {
		e.preventDefault();
		if (ctaDisabled) return;
		setLoading(true);

		getGameById(game?._id).then((res) => {
			if (res.status === 200) {
				updateStats({
					...group,
					actualScenario: 1,
					time: 0,
					lastVisited: ROUTES.START_GAME,
				});
				navigate(ROUTES.START_GAME2, {
					state: {
						activeScenario: 1,
					},
				});
			} else {
				setLoading(false);
			}
		});
	};

	return (
		<div className="start-game-page start-game-page--welcome">
			<div className="start-game-inner">
				<div className="start-game-grid">
					<div className="start-game-visual">
						<span className="start-game-badge">
							<span className="start-game-badge-dot" aria-hidden />
							Corporación Financiera Cobega
						</span>
						<div className="start-game-avatar-wrap">
							<div className="start-game-avatar-inner">
								<video
									ref={videoRef}
									autoPlay
									playsInline
									preload="auto"
									aria-label="Presentación visual"
								>
									<source src={presentacionDfVideo} type="video/mp4" />
								</video>
							</div>
						</div>
					</div>
					<div className="start-game-panel">
						<h1 className="start-game-title">
							Bienvenido al{" "}
							<span className="start-game-title-accent">
								futuro de Cobega
							</span>
						</h1>
						<p className="start-game-lead">
							Hola, han sido convocados para una misión decisiva: demostrar que son dignos de acceder a la COBEGA del futuro. 
						</p>
						<p className="start-game-lead start-game-lead-tight">
							Durante generaciones, este legado se ha construido con visión, esfuerzo, responsabilidad y compromiso. Hoy, la información confidencial sobre su futuro permanece protegida.
						</p>
						<p className="start-game-lead start-game-lead-tight">
							Para descubrirla, deberán superar un reto. Tendrán que demostrar que conocen nuestros orígenes, que comprenden los valores que nos han traído hasta aquí y que poseen el criterio necesario para mirar hacia adelante. Cada respuesta contará. Cada pista puede acercarles a la verdad.
						</p>
						<p className="start-game-lead start-game-lead-tight">
							Solo quienes estén a la altura podrán acceder a la información reservada que revela la próxima etapa de COBEGA. Trabajen en equipo. Piensen con rigor. No subestimen ningún detalle.
						</p>
						<p className="start-game-lead start-game-lead-tight">
							El futuro de COBEGA está en sus manos.
						</p>
						<div className="start-game-footer">
							<button
								type="button"
								className="start-game-cta"
								onClick={handleStartGame}
								disabled={ctaDisabled}
								aria-busy={loading}
							>
								{loading ? (
									<span
										className="start-game-cta-spinner"
										aria-hidden
									/>
								) : (
									<img
										className="start-game-cta-icon"
										src={flechaAvanzar}
										alt=""
									/>
								)}
								{loading ? "Cargando…" : "Continuar"}
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default GameIntroduction;
